var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMonitorCol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7002 2.25H4.03353C3.02101 2.25 2.2002 2.92157 2.2002 3.75V11.25C2.2002 12.0784 3.02101 12.75 4.03353 12.75H18.7002C19.7127 12.75 20.5335 12.0784 20.5335 11.25V3.75C20.5335 2.92157 19.7127 2.25 18.7002 2.25Z",
    stroke: "#1B90FE",
    strokeWidth: 1.39958,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7002 15.75H15.0335",
    stroke: "#1B90FE",
    strokeWidth: 1.39958,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.75V15.75",
    stroke: "#1B90FE",
    strokeWidth: 1.39958,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorCol);
export default __webpack_public_path__ + "static/media/monitor_col.b73ad1aedd1507fe04bf5b5195913d2a.svg";
export { ForwardRef as ReactComponent };